import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SuggestionListsService } from '../../../../services/suggestion-lists.service';
import { Router } from '@angular/router';
import { AdminService } from '../../../../../../../services/admin.service';

@Component({
  selector: 'app-action-sl-popup',
  templateUrl: './action-sl-popup.component.html',
  styleUrls: ['./action-sl-popup.component.css']
})
export class ActionSlPopupComponent implements OnInit {
  slList = null;
  actionText = '';
  reasonAction = '';
  btnActionText = '';
  action = '';
  dateOfPostpone: NgbDateStruct;
  todayDate: NgbDateStruct;
  notifyID;
  selectedRedirectDivision;
  selectedSLList;

  responseResultText = '';
  showErrorMsg = false;
  showSuccessMsg = false;
  disableBtn = false;

  departmentList = [];
  usersList = [];
  selectDepartment = null;
  selectUser = null;
  countOfDays = 1;

  constructor(public activeModal: NgbActiveModal,
    private router: Router,
    public suggestionListsService: SuggestionListsService,
    private adminService: AdminService) {
  }

  ngOnInit() {
    this.responseResultText = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    this.disableBtn = false;

    const date = new Date();

    this.dateOfPostpone = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };

    this.todayDate = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }

  onDepartmentChange(): void {
    if (this.selectDepartment) {
      let currentDep: any = this.departmentList.filter(deo => deo.id === this.selectDepartment); 
      this.usersList = currentDep[0].activeUsers;
      this.selectUser = null;
    } else {
      this.usersList = [];
    }
  }


  setSL(sl) {
    this.slList = sl;
  }

  disabledBtn() {
    return this.reasonAction.length >= 3;
  }

  setAllDevision(data) {
    this.departmentList = data;
  }

  setDivisionId(a, b, c) {
    this.selectedRedirectDivision = a;
    this.selectedSLList = b;
    this.notifyID = c;
  }

  setAction(actionPressrd) {
    this.action = actionPressrd;
    switch (this.action) {
      case 'redirect':
        this.actionText = 'REASON_FOR_REASSIGN';
        this.btnActionText = 'Ok';
        break;
      case 'cancel':
        this.actionText = 'CANCELLATION_REASON';
        this.btnActionText = 'CANCEL_LIST';
        break;
      case 'postpone':
      case 'updatePostponement':
        this.actionText = 'POSTPONING_REASON';
        this.btnActionText = 'POSTPONE_LIST';
        break;
      case 'implement':
        this.actionText = 'IMPLEMENTATION_RESULT';
        this.btnActionText = 'IMPLEMENT_SUGGESTION_LIST';
        break;
      case 'close':
        this.actionText = 'REASON';
        this.btnActionText = 'CANCEL';
        break;
      case 'restore':
        this.actionText = 'REASON';
        this.btnActionText = 'RESTORE';
        break;
      case 'createCEO':
          this.actionText = 'DESCRIPTION';
          this.btnActionText = 'CREATE';
          break;
    }
  }

  onAction() {
    switch (this.action) {
      case 'redirect':
        this.redirectToNewHead();
        break;
      case 'cancel':
        this.cancelRequest();
        break;
      case 'postpone':
        this.postponeRequest();
        break;
      case 'updatePostponement':
        this.updatePostponementRequest();
        break;
      case 'implement':
        this.implementRequest();
        break;
      case 'close':
        this.activeModal.dismiss(this.reasonAction);
        break;
      case 'restore':
        this.activeModal.dismiss(this.reasonAction);
        break;
      case 'createCEO':
        let send = {
          slId: this.selectedSLList,
          taskDeadline: this.countOfDays,
          userId: this.selectUser,
          groupId: this.selectDepartment,
          taskDescription: this.reasonAction
        }
        this.activeModal.dismiss(send);
        break;
    }
  }

  markNotify(itemId) {
    const sendingParams = {
      id: itemId,
      notificationCategory: "SUGGESTION"
    };
    this.adminService.notifyIsView(sendingParams).subscribe(
      (response: any) => { },
      () => {
      }
    );
  }

  redirectToNewHead() {
    this.suggestionListsService.redirectSL(this.reasonAction, this.selectedRedirectDivision, this.selectedSLList).subscribe(
      (res: any) => {

        if (res.status === 200 || res.status === 201) {
          if (this.router.url.includes('ex-suggestion-expired')) {
            this.markNotify(this.notifyID);
            this.responseResultText = 'REASSIGNING_COMPLETED_SUCCESSFULLY';
            this.showErrorMsg = false;
            this.showSuccessMsg = true;
            this.router.navigate(['/ex-notifications']);
            this.activeModal.dismiss('Cross click');
          } else {
            this.responseResultText = 'REASSIGNING_COMPLETED_SUCCESSFULLY';
            this.showErrorMsg = false;
            this.showSuccessMsg = true;
            this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
            this.activeModal.dismiss('Cross click');
          }
        } else {
          this.responseResultText = 'COULD_NOT_REASSIGN';
          this.showErrorMsg = true;
          this.showSuccessMsg = false;
          this.disableBtn = false;
        }
      },
      (err) => {
        if(err.error.status === 409) {
          this.responseResultText = 'T_O_R_S';
          this.showErrorMsg = true;
          this.showSuccessMsg = false;
          this.disableBtn = false; 
        } else {
          this.responseResultText = 'C_R_S_E';
          this.showErrorMsg = true;
          this.showSuccessMsg = false;
          this.disableBtn = false;
        }
      }
    );
  }

  // CANCEL SL
  cancelRequest() {
    this.responseResultText = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    this.disableBtn = true;
    this.suggestionListsService.cancelSL(this.reasonAction, this.slList.id).subscribe(
      (res: any) => {
        if (res.status === 200 || res.status === 201) {
          if (this.router.url.includes('ex-suggestion-expired')) {
            this.markNotify(this.notifyID);
            this.responseResultText = 'CANCELLATION_WAS_SUCCESSFU';
            this.showErrorMsg = false;
            this.showSuccessMsg = true;
            this.router.navigate(['/ex-notifications']);
            this.activeModal.dismiss('Cross click');
            this.disableBtn = false;
          } else {
            this.responseResultText = 'CANCELLATION_WAS_SUCCESSFU';
            this.showErrorMsg = false;
            this.showSuccessMsg = true;
            // this.suggestionListsService.showSuccessMsgForReviewList = false;
            this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
            this.activeModal.dismiss('Cross click');
            this.disableBtn = false;
          }
        } else {
          this.responseResultText = 'CANCELLATION_HAS_NOT_PASSED';
          this.showErrorMsg = true;
          this.showSuccessMsg = false;
          this.disableBtn = false;
        }
      },
      () => {
        this.responseResultText = 'C_H_S';
        this.showErrorMsg = true;
        this.showSuccessMsg = false;
        this.disableBtn = false;
      }
    );
  }

  // POSTPONE SL
  postponeRequest() {
    this.responseResultText = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    this.disableBtn = true;

    if (this.isDateValid()) {
      this.suggestionListsService.postponeSL(this.reasonAction, this.dateOfPostpone, this.slList.id).subscribe(
        (res: any) => {
          if (res.status === 200 || res.status === 201) {
            if (this.router.url.includes('ex-suggestion-expired')) {
              this.markNotify(this.notifyID);
              this.responseResultText = 'POSTPONING_WAS_SUCCESSFUL';
              this.showErrorMsg = false;
              this.showSuccessMsg = true;
              this.router.navigate(['/ex-notifications']);
              this.activeModal.dismiss('Cross click');
              this.disableBtn = false;
            } else {
              this.responseResultText = 'POSTPONING_WAS_SUCCESSFUL';
              this.showErrorMsg = false;
              this.showSuccessMsg = true;
              this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
              this.activeModal.dismiss('Cross click');
              this.disableBtn = false;
            }
          } else {
            this.responseResultText = 'POSTPONING_HAS_NOT_PASSED';
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.disableBtn = false;
          }
        },
        (err) => {
          if(err.error.status == 400) {
            this.responseResultText = err.error.message;
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.disableBtn = false;
          } else {
            this.responseResultText = 'P_H_S';
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.disableBtn = false;
          }
        }
      );

    } else {
      this.responseResultText = 'CHOOSE_DATE_FOR_AT_LEAST_ONE_DAY_MORE_THAN_TODAY.';
      this.showErrorMsg = true;
      this.showSuccessMsg = false;
      this.disableBtn = false;
    }
  }

  updatePostponementRequest() {
    this.responseResultText = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    this.disableBtn = true;

    if (this.isDateValid()) {
      this.suggestionListsService.updatePostponementSL(this.reasonAction, this.dateOfPostpone, this.slList.id).subscribe(
        (res: any) => {
          if (res.status === 200 || res.status === 201) {
            if (this.router.url.includes('ex-suggestion-expired')) {
              this.markNotify(this.notifyID);
              this.responseResultText = 'POSTPONING_WAS_SUCCESSFUL';
              this.showErrorMsg = false;
              this.showSuccessMsg = true;
              this.router.navigate(['/ex-notifications']);
              this.activeModal.dismiss('Cross click');
              this.disableBtn = false;
            } else {
              this.responseResultText = 'POSTPONING_WAS_SUCCESSFUL';
              this.showErrorMsg = false;
              this.showSuccessMsg = true;
              this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
              this.activeModal.dismiss('Cross click');
              this.disableBtn = false;
            }
          } else {
            this.responseResultText = 'OSTPONING_HAS_NOT_PASSED';
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.disableBtn = false;
          }
        },
        (err) => {
            this.responseResultText = 'P_H_S';
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.disableBtn = false;
        }
      );

    } else {
      this.responseResultText = 'CHOOSE_DATE_FOR_AT_LEAST_ONE_DAY_MORE_THAN_TODAY.';
      this.showErrorMsg = true;
      this.showSuccessMsg = false;
      this.disableBtn = false;
    }
  }

  implementRequest() {
    this.responseResultText = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    this.disableBtn = true;

    this.suggestionListsService.implementSL(this.reasonAction, this.slList.id).subscribe(
      (res: any) => {
        if (res.status === 200 || res.status === 201) {
          if (this.router.url.includes('ex-suggestion-expired')) {
            this.markNotify(this.notifyID);
            this.responseResultText = 'IMPLEMENTATION_WAS_SUCCESSFUL';
            this.showErrorMsg = false;
            this.showSuccessMsg = true;
            this.router.navigate(['/ex-notifications']);
            this.activeModal.dismiss('Cross click');
            this.disableBtn = false;
          } else {
            this.responseResultText = 'IMPLEMENTATION_WAS_SUCCESSFUL';
            this.showErrorMsg = false;
            this.showSuccessMsg = true;
            this.router.navigate(['/dashboard/my-suggestion-lists/my-lists']);
            this.activeModal.dismiss('Cross click');
            this.disableBtn = false;
          }
        } else {
          this.responseResultText = 'IMPLEMENTATION_HAS_NOT_PASSED';
          this.showErrorMsg = true;
          this.showSuccessMsg = false;
          this.disableBtn = false;
        }
      },
      () => {
        this.responseResultText = 'I_H_P';
        this.showErrorMsg = true;
        this.showSuccessMsg = false;
        this.disableBtn = false;
      }
    );
  }


  // Date validation for postponing
  isDateValid() {
    if (this.dateOfPostpone.year > this.todayDate.year) {
      return true;
    } else if (this.dateOfPostpone.year === this.todayDate.year) {
      // This year
      if (this.dateOfPostpone.month > this.todayDate.month) {
        return true;
      } else if (this.dateOfPostpone.month === this.todayDate.month) {
        return this.dateOfPostpone.day > this.todayDate.day;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/popups/action-sl-popup/action-sl-popup.component.ts